export default [
    // Keep `/organizer` as a legacy URL for backward compatibility while `/anbietende` is the canonical path.
    {
        path: '/organizer',
        meta: {
            title: 'ui.organizer.landing.hero.title',
            isOrganizerSection: true,
        },
        component: () => import('@/views/landing/organizer/OrganizerLandingPageView.vue'),
    },
    {
        path: '/anbietende',
        name: 'organizer-landing-page',
        meta: {
            title: 'ui.organizer.landing.hero.title',
            isOrganizerSection: true,
        },
        component: () => import('@/views/landing/organizer/OrganizerLandingPageView.vue'),
    },
    {
        path: '/kontakt',
        name: 'contact',
        meta: {
            title: 'ui.contact.hero.title',
        },
        component: () => import('@/views/contact/ContactPageView.vue'),
    },
    {
        path: '/',
        name: 'home',
        meta: {
            title: 'ui.participant.landing.hero.title.part1',
        },
        component: () => import('@/views/landing/participant/ParticipantLandingPageView.vue'),
    },
]
